import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as _ from 'lodash';
import { ITimeBlockComponentItem } from '../../../../features/calendar/components/time-block/types/time-block-component-item-types';
import {
  multipleTimeBlocksDeleted,
  purgeTimeBlockStore,
  setActiveTimerTimeBlock,
  setInitialTimeBlocks,
  setTimeBlocksForTask,
  timeBlockAdded,
  timeBlockDeleted,
  timeBlockUpdated,
} from './time-blocks.actions';

export interface TimeBlocksState extends EntityState<ITimeBlockComponentItem> {}

export const timeBlockAdapter: EntityAdapter<ITimeBlockComponentItem> =
  createEntityAdapter<ITimeBlockComponentItem>();
export const initialState: TimeBlocksState = timeBlockAdapter.getInitialState();

export const timeBlocksReducer = createReducer(
  initialState,
  on(timeBlockAdded, (state, { payload }) => {
    const addedTimeBlock = payload.modifiedTimeBlockItems[0];
    const clone = _.cloneDeep(addedTimeBlock);
    return timeBlockAdapter.addOne(clone, state);
  }),
  on(timeBlockUpdated, (state, { payload }) => {
    const updatedTimeBlocks = payload.modifiedTimeBlockItems;
    const clonedTimeBlocks = updatedTimeBlocks.map((block) => _.cloneDeep(block));
    return timeBlockAdapter.setMany(clonedTimeBlocks, state);
  }),
  on(timeBlockDeleted, (state, { payload }) => {
    const id = payload.deletedTimeBlockId;
    return timeBlockAdapter.removeOne(id, state);
  }),
  on(multipleTimeBlocksDeleted, (state, { payload }) => {
    const ids = payload.deletedTimeBlockIds;
    return timeBlockAdapter.removeMany(ids, state);
  }),
  on(setInitialTimeBlocks, (state, { payload }) => {
    const clonedTimeBlocks = payload.map((item) => _.cloneDeep(item));
    return timeBlockAdapter.setAll([...clonedTimeBlocks], state);
  }),
  on(setTimeBlocksForTask, (state, { payload }) => {
    const clonedTimeBlocks = payload.map((item) => _.cloneDeep(item));
    return timeBlockAdapter.setAll([...clonedTimeBlocks], state);
  }),
  on(setActiveTimerTimeBlock, (state, { payload }) => {
    if (!payload) {
      const activeEntity = Object.values(state.entities).find(
        (entity) => entity?.timeBlockModel.isActive,
      );

      if (!activeEntity) {
        return state; // nothing to remove
      }

      return timeBlockAdapter.removeOne(activeEntity.id, state);
    }

    const cloned = _.cloneDeep(payload);
    return timeBlockAdapter.setOne(cloned, state);
  }),
  on(purgeTimeBlockStore, (state) => {
    return timeBlockAdapter.removeAll(state);
  }),
);
